import classes from "./integrationStyles.module.scss"
import { useEffect, useState } from 'react';
import XMLViewer from 'react-xml-viewer'

const InvoiceDocsXml = ({xml, onExecuteResponse, minHeight=true, ...props})=>{
    const [keyState, setKeystate] = useState(0);
    console.log(xml);
    useEffect(() => {
        setKeystate(keyState+1)
    }, [onExecuteResponse])

    return(<>
    <div className={`${classes["container-limit"]}`} style={minHeight ? {minHeight:"80vh"} :  {width:"100%"}}>
        {/* <textarea value={xml} style={{width:"100%", height:"100%", whiteSpace:"pre"}} disabled/> */}
        <XMLViewer xml={xml}/>
    </div>
    </>)
}

export default InvoiceDocsXml;